import { spacing } from '@nib-components/theme';
const validFlexWidthValues = [
    'content',
    '1/2',
    '1/3',
    '2/3',
    '1/4',
    '3/4',
    '1/5',
    '2/5',
    '3/5',
    '4/5',
    '1'
];
const validTilesColumnsValues = [
    0,
    1,
    2,
    3,
    4,
    5,
    6
];
const validFlexAlignValues = [
    'center',
    'right',
    'left'
];
const validFlexVerticalAlignValues = [
    'center',
    'top',
    'bottom',
    'stretch'
];
export const isValidSpacing = (value)=>value || value === 0;
export const getSpacingValue = (value)=>spacing[value];
export const isList = (el)=>el === 'ul' || el === 'ol';
// eslint-disable-next-line  @typescript-eslint/no-explicit-any
export const mapFlexWidths = (width)=>{
    switch(width){
        case '1/2':
            return 1 / 2 * 100;
        case '1/3':
            return 1 / 3 * 100;
        case '2/3':
            return 2 / 3 * 100;
        case '1/4':
            return 1 / 4 * 100;
        case '3/4':
            return 3 / 4 * 100;
        case '1/5':
            return 1 / 5 * 100;
        case '2/5':
            return 2 / 5 * 100;
        case '3/5':
            return 3 / 5 * 100;
        case '4/5':
            return 4 / 5 * 100;
    }
};
export const mapColumnstoFlexBasis = (columns)=>{
    switch(columns){
        case 1:
        default:
            return `flex: 0 0 100%;`;
        case 2:
            return `flex: 0 0 50%;`;
        case 3:
            return `flex: 0 0 33.3333333333%;`;
        case 4:
            return `flex: 0 0 25%;`;
        case 5:
            return `flex: 0 0 20%;`;
        case 6:
            return `flex: 0 0 16.6666666667%;`;
    }
};
export const mapFlexAlignment = (flexAlignment)=>{
    if (flexAlignment === 'center') {
        return 'center';
    } else if (flexAlignment === 'right' || flexAlignment === 'bottom') {
        return 'flex-end';
    } else if (flexAlignment === 'left' || flexAlignment === 'top') {
        return 'flex-start';
    } else {
        return 'stretch';
    }
};

//# sourceMappingURL=utils.js.map